import { render, staticRenderFns } from "./AccordionForCreateRecord.vue?vue&type=template&id=499a3617&"
import script from "./AccordionForCreateRecord.vue?vue&type=script&lang=js&"
export * from "./AccordionForCreateRecord.vue?vue&type=script&lang=js&"
import style0 from "./AccordionForCreateRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports